/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_Tasks_DescInputs */

const en_mk_preview_tasks_desc = /** @type {(inputs: Mk_Preview_Tasks_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a board or list. Assign owners, leave comments, and check completion evidence.`)
};

const id_mk_preview_tasks_desc = /** @type {(inputs: Mk_Preview_Tasks_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gunakan papan atau daftar. Tetapkan penanggung jawab, beri komentar, dan periksa bukti penyelesaian.`)
};

/**
* | output |
* | --- |
* | "Use a board or list. Assign owners, leave comments, and check completion evidence." |
*
* @param {Mk_Preview_Tasks_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_tasks_desc = /** @type {((inputs?: Mk_Preview_Tasks_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_Tasks_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_tasks_desc(inputs)
	return en_mk_preview_tasks_desc(inputs)
});